<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card-body">
                    <h2 class="table-heading">
                        Customer Parking
                    </h2>

                    <!--site-dropdrown-->

                    <div>
                        <label class="col-sm-2 col-form-label">SITES: <span class="danger">*</span></label>
                        <select v-model="selectedSite" @change="onSiteChange" class="form-select">
                            <option value="" required disabled>Select a site </option>
                            <option v-for="site in sites" :key="site.id" :value="site.id">
                                {{ site.name }}
                            </option>
                        </select>
                    </div>


                    <!--Plate input and Add/extend stay-->
                    <div v-if="selectedSite">
                        <label class="col-form-label">REGISTRATION <span class="danger">*</span> </label>
                        <input class="form-control" @keypress="error = ''"
                           v-model="plateInput"  maxlength="15" 
                            placeholder="Add Registration Plate" style="text-transform: uppercase;" required />
               
                        <p v-if="error" style="color: red;">{{ error }}</p>
                        <button style="margin-top: 8px;" class="btn btn-primary" @click="addAndExtendPlate">Extend stay until midnight</button>
                    </div>

                    <!--Parking table-->
                    <div class="table-responsive">
                        <div class="col-12">
                            <!-- Table header and filter -->
                            <div v-if="selectedSite">
                                <table class="table table-borderless">
                                    <thead>
                                        <tr>
                                            <th>
                                                Registration Plate
                                                <input class="form-control" v-model="filterPlate"
                                                    @input="applyFilterDebounced"
                                                    placeholder="Search Registration Plate"
                                                    style="max-width: 50%; text-transform: uppercase;" />
                                            </th>
                                            <th>Added</th>
                                            <th>Expiry</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Show entries if available -->
                                        <tr v-if="parkingEntries.length > 0" v-for="entry in parkingEntries"
                                            :key="entry.vehicle_id + entry.added">
                                            <td style="text-transform: uppercase;">
                                                <span class="vrm bold number-plate-gbr">{{ entry.plate }}</span>
                                            </td>
                                            <td>{{ formatDate(entry.added) }}</td>
                                            <td>{{ formatDate(entry.expiry) }}</td>
                                        </tr>
                                        <!-- Show message if no entries -->
                                        <tr v-else>
                                            <td colspan="3" class="text-center text-muted py-4">
                                                <em>{{ filterPlate ? 'No parking entries match your search' : 'No parking entries found for this site' }}</em>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-show="loading" style="width: 100%; text-align: center">
                                    <div class="spinner-border" style="height: 4rem; width: 4rem" role="status">
                                        <span class="visually-hidden">{{ $t("events.loading") }}...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import ClientService from "../../services/client.service";
import authHeader from "@/services/auth-header";


export default {

    name: "Customer Parking",

    data() {
        return {
            sites: [],
            selectedSite: "",
            parkingEntries: [],
            filterPlate: "",
            currentParams: {},
            filterTimeout: null,
            loading: false,
            error: '',

        };
    },
    computed: {
        filteredPlates() {
            const term = (this.plateInput || "").toUpperCase().trim();
            if (!term) return [];
            return matches.slice(0, 10);
        },
    },

    async mounted() {
        await this.loadSites();
    },
    methods: {
        //Load 
        async loadSites() {
            const sites = await ClientService.getClientSites(
                this.$store.state.auth.user.selectedClient,
                null,
                null,
                null
            );
            if (sites) {
                this.sites = sites.data;
            } else {
                console.error("No sites available");
            }

        },

        onSiteChange() {

            this.filterPlate = "",
                this.loadParkingWhitelist();

        },

        loadParkingWhitelist(extraParams = {}) {
            if (!this.selectedSite)
                return;
            this.loading = true;
            const params = {
                ...extraParams,
            };

            if (this.filterPlate || this.filterPlate !== '') {
                params.plate = this.filterPlate
            }

            this.currentParams = params;


            axios
                .get(`https://api.varsanpr.com/api/customerparkingwhitelist/${this.selectedSite}`, {
                    params,
                    headers: authHeader(),

                })

                .then((response) => {
                    if (!response.data.success) {
                        this.parkingEntries = [];
                        return;
                    }
                    this.parkingEntries = response.data.data || [];
                    this.loading = false;


                })
                .catch((err) => {
                    console.error("Failed to load parking whitelist:", err)
                    alert("Error loading whitelist: " + err.message);
                })
        },

        addAndExtendPlate() {
            if (!this.plateInput || !this.selectedSite) {
              this.error = 'Please enter the registration.'
                return; 
            }
            if (this.plateInput.trim() == "") {
                this.error = 'Please enter the registration.'
            } else {
                this.error = '';
                console.log('Submitted:', this.plateInput);
            }

            const addedPlate = this.plateInput.toUpperCase();
            axios
                .post(`https://api.varsanpr.com/api/customerparkingwhitelist/${this.selectedSite}`, {

                    plate: this.plateInput,
                    headers: authHeader(),

                })

                .then((response) => {
                    if (response.data.success) {
                        this.$success(`${addedPlate} added successfully! `)
                        this.plateInput = "";
                        this.loadParkingWhitelist();
                    }

                })

                .catch((err) => {
                    console.error("Failed to add/extend plate", err);
                });
        },
        //format date 
        formatDate(dateString) {
            if (!dateString)
                return "";
            const fixed = dateString.replace(" ", "T");
            const date = new Date(fixed);
            return date.toLocaleString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit"

            });
        },

        applyFilterDebounced() {
            if (this.filterTimeout) clearTimeout(this.filterTimeout);
            this.filterTimeout = setTimeout(() => {
                this.loadParkingWhitelist();
            }, 300);
        },

    }

};
</script>